import { AttachCircle, Send } from "iconsax-react";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { getToken } from "../../../utils/token";
import instance from "../../../axios/instance";

export const MessageInput = ({
  message,
  setMessage,
  handleSubmit,
  source,
  getMessagePayloadAndEvent,
  setMessages,
  socket,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(null);

  const handleAttach = (e) => {
    const file = e.target.files[0];
    // console.log(file);
    if (file) {
      setSelectedFile(file);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedFile(null);
    setError(null);
  };

  const handleSendFile = async (file) => {
    const { messagePayload, staticMessagePayload, event } =
      getMessagePayloadAndEvent(file.name || "file");
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("id", messagePayload.id);

      setMessages((messages) => [
        ...messages,
        { ...staticMessagePayload, isFile: true, pending: true },
      ]);

      const token = getToken();
      const response = await instance.post(
        "/doctor/messages/file",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const payload = {
        ...messagePayload,
        ...response.data,
        fileType: file.type,
        isFile: true,
      };
      socket.emit(event, payload);
      setMessages((messages) => {
        const updatedMessages = messages.map((message) => {
          if (message.id === response.data.id) {
            return {
              ...message,
              ...payload,
              file_path: response.data.filePath,
              file_name: response.data.fileName,
              file_size: response.data.fileSize,
              file_type: file.type,
              pending: false,
            };
          }
          return message;
        });
        return updatedMessages;
      });
    } catch (error) {
      toast.error("Failed to send file");
      setMessages((messages) => {
        const updatedMessages = messages.map((message) => {
          if (message.id !== messagePayload.id) {
            return message;
          }
        });
        return updatedMessages;
      });
    }
  };

  const handleSendingFile = () => {
    // Handle file submission here
    if (selectedFile && selectedFile.size >= 10000000) {
      setError("File size should not be greater than 10MB");
      return;
    }
    handleSendFile(selectedFile);
    setShowModal(false);
    setSelectedFile(null);
  };

  const modalContent = (
    <div
      className={`absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50`}
    >
      <div className="bg-white p-6 rounded-lg max-w-2xl w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">File Preview</h3>
          <button
            onClick={() => handleCloseModal()}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        <div className="mb-4">
          <p className="text-sm text-gray-600">
            Selected file:{" "}
            <strong className="font-medium">{selectedFile?.name}</strong>
          </p>
          {selectedFile?.type.startsWith("image/") ? (
            <>
              <img
                src={URL.createObjectURL(selectedFile)}
                alt="Preview"
                className="mt-2 max-h-[400px] object-contain border rounded-md"
              />
              <p className="text-xs text-gray-500 mt-2">
                Size: {(selectedFile?.size / 1024 / 1024).toFixed(2)} MB
              </p>
            </>
          ) : (
            <div className="mt-2 p-4 bg-gray-100 rounded">
              <p>File type: {selectedFile?.type || "Unknown"}</p>
              <p>Size: {(selectedFile?.size / 1024 / 1024).toFixed(2)} MB</p>
            </div>
          )}
        </div>

        {error && <div className="mb-4 text-red-500 text-sm">{error}</div>}

        <div className="flex justify-end gap-2">
          <button
            onClick={() => handleCloseModal()}
            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark"
            onClick={handleSendingFile}
          >
            Send <Send size="22" color="#aaa" />
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className={`absolute ${
          source === "main" ? "bottom-0" : "bottom-3"
        } right-0 left-0 bg-white grid grid-cols-[22px_auto] gap-x-2 items-center ${
          source === "main" ? "mt-4" : "mt-0"
        } mx-5`}
      >
        <label htmlFor="file" className="max-w-[22px] mx-auto" type="button">
          <input
            type="file"
            name="file"
            id="file"
            className="hidden"
            onChange={handleAttach}
            accept=".pdf,.docx,.xlsx,.jpg,.jpeg,.png,.gif,.mp4,.mov,.avi,.mkv,.webm,.mp3,.wav,.m4a"
          />
          <AttachCircle
            size={22}
            className="text-[#555] hover:text-primary cursor-pointer"
          />
        </label>
        <div className="relative">
          <input
            type="text"
            name="msg"
            id="msg"
            className="h-[50px] w-full block rounded-md border outline-none focus:border-primary px-3 text-sm pr-10"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            autoComplete="off"
          />
          <button
            type="submit"
            className="absolute right-[1px] bg-[#f4f4f4] hover:bg-primary-light w-[35px] cursor-pointer top-[1px] bottom-[1px] rounded-r-md border-l flex items-center justify-center"
          >
            <Send size="22" color="#aaa" />
          </button>
        </div>
      </form>

      {/* File Preview Modal */}
      {showModal && modalContent}
    </>
  );
};
